export default {"src":"/_next/static/media/forward-some-icon.4f8736e7.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};